import { applyPatches } from './patch';
applyPatches(process.cwd(), false);
//# sourceMappingURL=patch-cli.js.map